export default function Svg(props) {
    let img = require("../images/icon-" + props.name + ".svg");
    return <img className={props.class} src={img} alt={props.name} />;
}
